<template>
  <div class="svoi-loader" :class="classes">
    <div class="loader"></div>
    <div v-if="label" class="label">{{ label }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue-demi'
import { SizesEnum, Sizes } from '@svoi-ui/interfaces/loader'
import { isString } from '@svoi-ui/shared/utils/guards'

export default defineComponent({
  name: 'SvoiLoader',
  props: {
    label: {
      type: String,
      default: 'Загрузка...'
    },
    size: {
      type: String as PropType<Sizes | string>,
      default: SizesEnum.m,
      validator: (value: unknown) => {
        return (
          isString(value) &&
          [
            SizesEnum.xs.toString(),
            SizesEnum.s.toString(),
            SizesEnum.m.toString(),
            SizesEnum.l.toString(),
            SizesEnum.xl.toString(),
            SizesEnum.xxl.toString()
          ].includes(value)
        )
      }
    }
  },
  setup(props) {
    const classes = computed(() => ({
      [`-size-${props.size}`]: true
    }))

    return { classes }
  }
})
</script>

<style lang="scss" scoped>
@use '@svoi-ui/assets/scss/components/loader.scss';
</style>
